import { createClientResponse } from '../../utils/pollard'

export default () => {
  return createClientResponse(() => window.location.href.indexOf('home') > -1)
}
